import { application } from "./application"

import HintsController from "./hints_controller"
application.register("hints", HintsController)

import AlertsController from "./alerts_controller"
application.register("alerts", AlertsController)
